// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indexeddb-guard-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.indexeddb-guard-checking {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}

.indexeddb-guard-content {
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 500px;
}

.indexeddb-guard-error-content {
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 20px;
}

.indexeddb-guard-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: indexeddb-guard-spin 1s linear infinite;
}

.indexeddb-guard-title {
  color: #333;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: normal;
}

.indexeddb-guard-error-title {
  color: #d32f2f;
  margin-bottom: 20px;
  font-size: 28px;
}

.indexeddb-guard-message {
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

.indexeddb-guard-error-message {
  color: #666;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 30px;
}

.indexeddb-guard-error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.indexeddb-guard-troubleshooting {
  text-align: left;
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.indexeddb-guard-list {
  margin-top: 15px;
  padding-left: 20px;
}

.indexeddb-guard-actions {
  margin-top: 30px;
  display: flex;
  gap: 15px;
  justify-content: center;
}

.indexeddb-guard-retry-button {
  padding: 12px 30px;
  font-size: 16px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.indexeddb-guard-retry-button:hover {
  background-color: #2980b9;
}

.indexeddb-guard-help-link {
  padding: 12px 30px;
  font-size: 16px;
  color: #3498db;
  border: 2px solid #3498db;
  border-radius: 6px;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.3s;
}

.indexeddb-guard-help-link:hover {
  background-color: #e3f2fd;
}

.indexeddb-guard-warning-box {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: left;
}

.indexeddb-guard-persistent-error {
  margin-top: 20px;
  padding: 15px;
  background-color: #ffebee;
  border-radius: 6px;
  color: #c62828;
}

@keyframes indexeddb-guard-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/IndexedDBGuard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".indexeddb-guard-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.indexeddb-guard-checking {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9999;\n}\n\n.indexeddb-guard-content {\n  text-align: center;\n  padding: 40px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n}\n\n.indexeddb-guard-error-content {\n  text-align: center;\n  padding: 40px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  margin: 20px;\n}\n\n.indexeddb-guard-spinner {\n  width: 50px;\n  height: 50px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #3498db;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  animation: indexeddb-guard-spin 1s linear infinite;\n}\n\n.indexeddb-guard-title {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 24px;\n  font-weight: normal;\n}\n\n.indexeddb-guard-error-title {\n  color: #d32f2f;\n  margin-bottom: 20px;\n  font-size: 28px;\n}\n\n.indexeddb-guard-message {\n  color: #666;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.indexeddb-guard-error-message {\n  color: #666;\n  font-size: 16px;\n  line-height: 1.5;\n  margin-bottom: 30px;\n}\n\n.indexeddb-guard-error-icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.indexeddb-guard-troubleshooting {\n  text-align: left;\n  margin-top: 30px;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n}\n\n.indexeddb-guard-list {\n  margin-top: 15px;\n  padding-left: 20px;\n}\n\n.indexeddb-guard-actions {\n  margin-top: 30px;\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.indexeddb-guard-retry-button {\n  padding: 12px 30px;\n  font-size: 16px;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.indexeddb-guard-retry-button:hover {\n  background-color: #2980b9;\n}\n\n.indexeddb-guard-help-link {\n  padding: 12px 30px;\n  font-size: 16px;\n  color: #3498db;\n  border: 2px solid #3498db;\n  border-radius: 6px;\n  text-decoration: none;\n  display: inline-block;\n  transition: background-color 0.3s;\n}\n\n.indexeddb-guard-help-link:hover {\n  background-color: #e3f2fd;\n}\n\n.indexeddb-guard-warning-box {\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  padding: 15px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.indexeddb-guard-persistent-error {\n  margin-top: 20px;\n  padding: 15px;\n  background-color: #ffebee;\n  border-radius: 6px;\n  color: #c62828;\n}\n\n@keyframes indexeddb-guard-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
